module.exports = __webpack_public_path__ + "img/course.42ec1aff.png";